var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      position: "relative"
    },
    on: {
      click: function ($event) {
        return _vm.$emit("itemClick");
      }
    }
  }, [_vm.pageType == "DETAILS" ? _c("top-title", {
    attrs: {
      themeColor: "#" + _vm.themeColor
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("产品须知")))])]) : _vm._e(), _vm.styleObj.controlsComponentsMark == "product1" ? _c("div", {
    staticClass: "listBox"
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]), _c("div", {
      style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
    }, [_vm._v(_vm._s(_vm.$t(item.value)))])]);
  }), 0) : _vm.styleObj.controlsComponentsMark == "product2" ? _c("div", {
    staticClass: "listBox2"
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("img", {
      staticClass: "img",
      attrs: {
        src: require("@/assets/template/product/" + _vm.styleObj.controlsComponentsMark + "_" + _vm.themeColor + "_" + item.icon + ".png")
      }
    }), _c("div", {
      staticClass: "name",
      style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]), _c("div", {
      staticClass: "des",
      style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
    }, [_vm._v(" " + _vm._s(_vm.$t(item.value)) + " ")])]);
  }), 0) : _vm.styleObj.controlsComponentsMark == "product3" ? _c("div", {
    staticClass: "listBox3"
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "left",
      style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]), _c("div", {
      staticClass: "right",
      style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
    }, [_vm._v(" " + _vm._s(_vm.$t(item.value)) + " ")])]);
  }), 0) : _vm._e(), !_vm.styleObj.isHiddenClause ? _c("div", {
    staticClass: "clauseBox",
    class: _vm.styleObj.controlsComponentsMark == "product2" ? "product2" : ""
  }, [_vm._v(" " + _vm._s(_vm.$t("更多请查看"))), _c("span", {
    style: "color:" + _vm.styleObj.clauseColor
  }, [_vm._v("《" + _vm._s(_vm.$t("投保须知")) + "》、《" + _vm._s(_vm.$t("保险条款")) + "》、《" + _vm._s(_vm.$t("投保声明")) + "》")])]) : _vm._e(), _c("div", [_vm._t("edit")], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };